export const SITES_NOTIFICATION_TYPES = {
  EDIT_SITE_NAME_FAILED: "Edit site name failed",       // notificationTypes[105]
  EDIT_SITE_CITY_FAILED: "Edit site city failed",       // notificationTypes[106]
  EDIT_SITE_DESCRIPTION_FAILED: "Edit site description failed", // notificationTypes[107]
  EDIT_SITE_FAILED: "Edit site failed",                 // notificationTypes[108]
  CAMPUS_UPDATE_SUCCESS:"Campus updated successfully"             
};

export const SITES_ERROR_MESSAGES = {
  SITE_DETAILS_FALLBACK: "Failed to update the site details. Please try again.",
};

export const SITES_CHANGED_FIELD_LABELS = {
  SITE_NAME: "site name",
  SITE_DESCRIPTION: "site description",
  SITE_LOCATION: "site location",
};
